const style = {
  flexStyle: {
    display: "flex",
    flexDirection: "column,",
  },

  sectionHeading: {
    fontFamily: "Arimo",
    fontWeight: 700,
    fontSize: "36px",
    lineHeight: "48px",
  },

  sectionSubHeading: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: "20px",
    color: "#555555",
    lineHeight: "19.2px",
  },
};

export default style;
